// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"395":"90016476","447":"31d6cfe0","517":"f58ca518","857":"5fb562a9"}[chunkId] + ".chunk.css";
};